/* eslint-disable */
import Container from '@components/Container/basic-container';
import { useGlobalContext } from 'contexts';
import { usePreviousRoute } from 'hook/nousePreviousRoute';
import Image from 'next/image';
import Link from 'next/link';
import { iframeStyle } from 'pages/privacy-policy';
import React, { useEffect } from 'react';
import { getPrevPath } from 'utils/pathUtils';
import { ROUTE_NAMES } from 'utils/routes';
import ninjacart63 from 'assets/ninjacart63.png';
import useEvents from 'hook/useEvents';
import { TraderEventType } from '@utils/eventsConstant';

const TnCLink = 'https://traders.trafyn.site/trader/terms-and-conditions';

function onlink(
  arg0: string
): React.MouseEventHandler<HTMLAnchorElement> | undefined {
  console.log('Function not implemented.');
}

function shareViaEmailSupport(email) {
  try {
    if (window) {
      if (window['Android']) {
        window['Android']?.openGmailApp(email);
      } else if (window['Native']) {
        window['Native']?.openGmailApp(email);
      }
    } else {
      // eslint-disable-next-line
      window.location.href =
        'https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=' + email;
    }
  } catch (e) {
    if (typeof window !== 'undefined') {
      window['location'].href = email;
    }
  }
}

function back(): React.MouseEventHandler<HTMLDivElement> | undefined {
  console.log('Function not implemented.');
}

function TermsCondition() {
  const { toggleHamBurger } = useGlobalContext();
  let prevPath = ROUTE_NAMES.DASHBOARD;
  const { triggerEvent } = useEvents();

  if (typeof window !== 'undefined') {
    prevPath = getPrevPath(window.location.search);
  }

  useEffect(() => {
    triggerEvent(TraderEventType.Generic_event, {
      eventName: 'Terms_success',
    });
  }, []);

  const onBack = React.useCallback(() => {
    toggleHamBurger(false);
  }, []);

  return (
    <Container
      isBackButton
      backUrl={prevPath}
      headerTitle="Terms and Conditions"
      childClassName="bg-gray-200"
      onBack={onBack}
    >
      <div className="content p-6 bg-white">
        <style jsx>{`
          .content {
            font-size: 0.9rem;
            word-break: break-word;
          }
          .line-break {
            border: 1px solid lightgray;
            margin: 5px auto;
          }
        `}</style>
        {/* <Image src={ninjacart63} style={{ width: '100%', height: 'auto' }} /> */}
        {/* <div className="content-center">//Add Terms and Conditions Here</div> */}
        {/* <div className="center text-white">
          By continuing you agree to our Privacy policy
        </div> */}
        <div>
          <div className="page__background page--material__background"></div>
          <div className="tc-header">
            <Image
              src={ninjacart63}
              style={{ width: '100%', height: 'auto' }}
            />
          </div>
          <div className="content tc-content">
            <div className="tc-list">
              <div className="tc">
                <div className="title content-center" style={{ marginTop: 0 }}>
                  Introduction
                </div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>Welcome to Ninja App!</span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The Ninja App (as defined below) is owned and operated by
                      63Ideas Infolabs Private Limited, a company incorporated
                      under the laws of India, having its registered office at
                      Vaishnavi Signature, 9th Floor, 78/9, Outer Ring Road,
                      Bellandur Village, Varthur, Hobli, Bengaluru - 560103
                      (hereinafter referred to as “Ninjacart”).
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      For the purpose of these terms and conditions (hereinafter
                      referred to as the “Terms”),
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <div>
                      <span>
                        (a) the term “Account” refers to the account created by
                        Users to access the Services.
                      </span>
                    </div>
                    <div>
                      <span>
                        (b) the term “App” refers to Ninjacart's mobile
                        application/desktop application called Ninja App which
                        is accessible at
                        <a
                          className="text-blue-600 m-1"
                          target={'_blank'}
                          href="https://play.google.com/store/apps/details?id=com.nc.trader&ah=
                          rpdGWa0WxmNs9_2THmD4VQqyu-8"
                        >
                          https://play.google.com/store/apps/details?id=com.nc.trader&ah=
                          rpdGWa0WxmNs9_2THmD4VQqyu-8
                        </a>
                      </span>
                    </div>
                    <div>
                      <span>
                        (c) the term "Applicable Law" or "Applicable Laws" as
                        the context may require, means and includes all laws,
                        ordinances, statutes, rules, orders, decrees,
                        injunctions, licenses, permits, approvals,
                        authorisations, consents, waivers, privileges,
                        agreements and regulations of any governmental authority
                        having jurisdiction over the relevant matter as such are
                        in effect as of the date hereof or as may be amended,
                        modified, enacted or revoked from time to time hereafter
                        including writs, judgment, injunction, decree or similar
                        order of any competent court or similar person having
                        jurisdiction over the relevant matter as such, are in
                        effect as of the date hereof.
                      </span>
                    </div>
                    <div>
                      <span>
                        (d) the term “Credit Facility Terms” refers to the terms
                        <span>
                          <a
                            onClick={(_) => onlink('credit-facility-container')}
                            className="link"
                          >
                            (accessible here)
                          </a>
                        </span>
                        applicable to eligible Users who choose to avail certain
                        value-added services.
                      </span>
                    </div>
                    <div>
                      <span>
                        (e) the terms “Ninja App” or “Platform” (which may be
                        used interchangeably), collectively refer to the Website
                        and App.
                      </span>
                    </div>
                    <div>
                      <span>
                        (f) the term “Privacy Policy” refers to Ninjacart's
                        privacy policy accessible at
                        <Link href={ROUTE_NAMES.PRIVACY_POLICY}>
                          https://ninjacart.in/privacy-policy.
                        </Link>
                      </span>
                    </div>
                    <div>
                      <span>
                        (g) the terms “Service” or “Services” as the context may
                        require, means access to the Platform that allows Users
                        to trade with a wide variety of buyers and sellers (in
                        India's agri-marketplace) and record and manage their
                        trades seamlessly with minimum effort and also allows
                        Users to pay and collect money from buyers and sellers
                        across India, via multiple payment options.
                      </span>
                    </div>
                    <div>
                      <span>
                        (h) the term “Service Content” refers to all forms of
                        content and information made available to a User of the
                        Platform, where such content and information may include
                        audio, video and software product material which may be
                        required by the User.
                      </span>
                    </div>
                    <div>
                      <span>
                        (i) the term “Third Parties” or “Third Party” (which may
                        be used interchangeably), refer to any third-party
                        service providers such as vendors and service providers
                        including logistics service providers, payment gateways
                        to process payments and manage payment card information
                        used by Ninjacart to provide Services.
                      </span>
                    </div>
                    <div>
                      <span>
                        (j) the term “User Information” refers to any
                        information provided by the User including but not
                        limited to name, date of birth, telephone number, email
                        address and residential address, for the creation of an
                        Account, for the purpose of availing/accessing the
                        Services or as may be required under the Credit Facility
                        Terms.
                      </span>
                    </div>
                    <div>
                      <span>
                        (k) the terms “User”, “you”, “yours”, as the context may
                        require, refer to, and include all individuals, natural
                        persons, legal persons (sole proprietors, partnership
                        firms, companies, LLPs, trusts, societies or HUFs) that
                        register on the Platform and/or use, transact or avail
                        the Services of the Platform.
                      </span>
                    </div>
                    <div>
                      <span>
                        (l) the terms “we”, “our” and “us” (which may be used
                        interchangeably), refer to Ninjacart.
                      </span>
                    </div>
                    <div>
                      <span>
                        (m) The term “Website” refers to Ninjacart's interactive
                        online website accessible at
                        <a
                          href="https://ninjacart.in/"
                          className="text-blue-600 m-1"
                          target={'_blank'}
                        >
                          https://ninjacart.in/
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      {' '}
                      By clicking on “I/We Accept” during the sign- up process,
                      you acknowledge that{' '}
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      (i) you have read, understood and accept these Terms and
                      Ninjacart's applicable policies, such as its Privacy
                      Policy (
                      <Link href={ROUTE_NAMES.PRIVACY_POLICY}>
                        https://ninjacart.in/privacy-policy.
                      </Link>
                      ), and
                    </span>
                  </div>
                  <div>
                    <span>
                      (ii) if you represent a person or entity, you confirm and
                      represent that you have the necessary power and authority
                      to bind such person and/or entity to these Terms and
                      Ninjacart's applicable policies, such as its Privacy
                      Policy;
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <div>
                      <span>
                        (a) you represent that you are 18 years or above and are
                        otherwise legally competent to enter into a binding
                        agreement.
                      </span>
                    </div>
                    <div>
                      <span>
                        (b) you represent that you are compliant with all
                        applicable laws, while using our Services.
                      </span>
                    </div>
                    <div>
                      <span>
                        (c) you represent that (i) you have the rights required
                        to provide the User Information to Ninjacart, and (ii)
                        any and all User Information provided to us by you is
                        accurate and valid.
                      </span>
                    </div>
                    <div>
                      <span>
                        (d) you accept these Terms and agree that you will
                        comply with and are legally bound by these Terms.
                      </span>
                    </div>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      Ninjacart may modify the Terms at any time by posting the
                      changes on the Platform and you agree that it shall be
                      your responsibility to ascertain the changes to the Terms,
                      by viewing the revised Terms. Ninjacart shall periodically
                      inform Users of the Terms, Privacy Policy and other
                      relevant terms that Users are bound by, and update Users
                      of any change in such terms (if any). Where required under
                      Applicable Laws, we will obtain your consent prior to any
                      material changes pertaining to your continued use of any
                      Services after the new and/or revised Terms are effective,
                      which would indicate that you have read, understood, and
                      agreed to those Terms.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      If at any time you find these Terms of service or use
                      unacceptable, you must immediately cease accessing the
                      Platform and all use of the Service therein. Further, if a
                      User chooses to avail certain financial services
                      facilitated by Ninjacart through the Platform, said User
                      will also be governed by the Credit Facility Terms
                      accessible here.
                    </span>
                  </div>
                </div>
              </div>
              <div className="tc">
                <div className="title">Use of the Service</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      Our Services are provided solely for your internal use by
                      you or your organization.{' '}
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      Except as expressly permitted in these Terms or as we may
                      otherwise permit, you may not use, reproduce, duplicate,
                      distribute, create derivative works based upon, publicly
                      display, publicly perform, publish, transmit, or otherwise
                      exploit the Service or its associated content for any
                      purpose whatsoever without obtaining our prior written
                      consent or, in the case of third-party content, the
                      relevant owner therein. In certain instances, we may
                      suggest, ask or otherwise permit you to download, install
                      or print Service Content. In such a case, you may do so
                      only in the manner authorized and for your non-commercial
                      use only. You acknowledge that you do not acquire any
                      ownership rights by downloading, installing or printing
                      Service Content.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      Any software that is made available to view and/or
                      download in connection with our Platform is owned or
                      controlled by us and/or licensors, affiliates and
                      suppliers and is protected by copyright laws and
                      international treaty provisions. Your use of the software
                      is governed by the terms of the end user license
                      agreement, if any, which accompanies or is included with
                      the software. We accept no responsibility or liability in
                      connection with any software owned or controlled by third
                      parties.
                    </span>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div className="tc">
                <div className="title">Account Registration</div>
                <div className="description">
                  <div>
                    <span>
                      The Users willing to avail the Services, are required to
                      register/create their own account on the Platform. For the
                      successful registration of your account, you are required
                      to provide us with User Information. All User Information
                      will be used and processed in accordance with these Terms,
                      the Privacy Policy. You agree to provide correct and valid
                      information details as required in order to complete the
                      registration process. Upon registration, the User will
                      receive a username, and have the option to access/log-in
                      to,
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      (i) the App, only via One Time Password (OTP) sent to the
                      User's phone number submitted as part of the registration
                      process, and
                    </span>
                  </div>
                  <div>
                    <span>
                      (ii) the Website, via OTP or password (as set by the
                      User).{' '}
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The User will be required to take all the necessary
                      measures for maintaining the privacy of their Account's
                      username and password created upon registration. The User
                      will also be responsible for any and all activities that
                      occur under through their account. Additionally, Users are
                      prohibited from selling, trading, or otherwise
                      transferring their Account to another party or
                      impersonating any other person for the purpose of creating
                      an Account on the Platform.
                    </span>
                  </div>
                  <div>
                    <span>
                      We encourage Users to use "Strong” passwords (i.e.,
                      passwords that use a combination of upper and lower case
                      letters, numbers and symbols) for their Account. You agree
                      to immediately notify us of any unauthorised use of the
                      Account or password. You will be solely responsible for
                      your acts on the Platform, including those conducted under
                      the username assigned to you or using your User
                      Information.
                    </span>
                  </div>
                  <div>
                    <span>
                      {' '}
                      Any data of your usage may be retained or deleted in
                      accordance with Applicable Laws.{' '}
                    </span>
                  </div>
                  <div>
                    <span>
                      Use of another User's Account information for availing the
                      Services is expressly prohibited.
                    </span>
                  </div>
                </div>
              </div>
              <div className="tc">
                <div className="title">Service Guidelines and Terms</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The Users may use the Platform to make and receive
                      payments when availing the Services, and keep track of
                      said transactions on the Platform. The User understands
                      and acknowledges that in order to facilitate the payment
                      or receipt of funds (as they relate to the Services)
                      through the Platform, Ninjacart uses the payment
                      infrastructure provided by a Third Party.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The information on security of these payment methods,
                      along with the information on any fees or charges payable
                      by you, charge back options (if any), will be provided to
                      you by the Third Party payment gateway provider.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      By opting to pay or receive payments through the Platform,
                      the User hereby authorises the Third-Party payment gateway
                      to generate an electronic funds transfer between the
                      payment system providers and the User's bank account to
                      process each transaction.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The Users should ensure that the transactions (including
                      the sale or purchase of goods and services) for which the
                      payment link is provided, comply with all Applicable Laws
                      being in force. In the event, any goods or services or any
                      transaction processed through the Platform violates any
                      law or is prohibited in any way, then
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      (i) the User shall be solely liable for any liability
                      arising from such transactions, and{' '}
                    </span>
                  </div>
                  <div>
                    <span>
                      (ii) Ninjacart reserves the right to suspend/terminate the
                      User's Account.{' '}
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      In order to make payments online via the Platform, you
                      undertake to use a valid payment card or bank details or
                      third-party wallets or details required for any other mode
                      of payment (hereinafter referred to as “Payment Details”)
                      with the authority to use the same, to have sufficient
                      funds or credit available to complete the payment on the
                      Platform in good standing. These Payment Details will be
                      provided by you to our Third-Party payment gateway
                      providers and will be governed by such payment gateway
                      providers' terms and policies. By providing the Payment
                      Details, you represent, warrant, and covenant that:
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <div>
                      <span>
                        {' '}
                        (a) you are legally authorized to provide such Payment
                        Details;{' '}
                      </span>
                    </div>
                    <div>
                      <span>
                        {' '}
                        (b) you are legally authorized to perform payments using
                        such Payment Details; and{' '}
                      </span>
                    </div>
                    <div>
                      <span>
                        (c) such action does not violate the terms and
                        conditions applicable to your use of such Payment
                        Details or Applicable Law.
                      </span>
                    </div>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The User shall not use the Platform for any transaction
                      that involves the sale or supply of prohibited products
                      and services, including without limitation to,
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <div>
                      <span>
                        a. sale of counterfeit, replicas and pirated goods and
                        goods infringing any intellectual property rights
                        including pirated recordings or copies of unauthorized
                        copyrighted materials whether in electronic or physical
                        form or any other medium which may not be in existence
                        at present;
                      </span>
                    </div>
                    <div>
                      <span>
                        b. sexually-oriented or pornographic products or
                        services;
                      </span>
                    </div>
                    <div>
                      <span>
                        c. products/services intended to inflict or promote
                        revenge, harassment, and other forms of abuse,
                        humiliation, and intimidation;
                      </span>
                    </div>
                    <div>
                      <span> d. weapons and ammunition; </span>
                    </div>
                    <div>
                      <span>
                        e. sale of tobacco and cigarettes which includes
                        cigarettes, cigars, chewing tobacco, and related
                        products;
                      </span>
                    </div>
                    <div>
                      <span>
                        {' '}
                        f. sale of liquor or any narcotic drugs and psychotropic
                        substances;{' '}
                      </span>
                    </div>
                    <div>
                      <span>
                        {' '}
                        g. sale / supply of any good or service which may not be
                        in public interest;{' '}
                      </span>
                    </div>
                    <div>
                      <span>
                        {' '}
                        h. gambling or other prohibited activities; or{' '}
                      </span>
                    </div>
                    <div>
                      <span>
                        i. sale / supply of good or service which results in
                        non-compliance of any Applicable Law.
                      </span>
                    </div>
                  </div>
                  <div>
                    <span>
                      In the event there is any delay or issue related to the
                      transaction, the User can contact the Ninjacart support
                      team at <strong>080-35018270</strong>. We will make
                      commercially reasonable efforts to resolve the issue
                      within a reasonable timeline. All refunds will be
                      processed by following the validation of the transaction
                      from case to case basis and in accordance with Applicable
                      Laws.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The User agrees and understands that, Ninjacart is not
                      liable or responsible or in any manner a party to any
                      transaction where the payment has been made outside the
                      Platform. Except to the extent otherwise required by
                      Applicable Laws, Ninjacart is not liable for any payments
                      authorized through the Platform using your Payment
                      Details.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The User agrees to cross-check the account details and
                      other details before initiating a transaction. If the User
                      had entered wrong account number /virtual account ID on
                      the Platform, then Ninjacart shall not be held
                      responsible, nor will we be in a position to initiate
                      refunds.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      {' '}
                      Further, Ninjacart is not liable for any payments that do
                      not complete because:{' '}
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <div>
                      <span>
                        (a) your payment card or bank/virtual account or
                        third-party wallet does not contain sufficient funds to
                        complete the transaction, or the transaction exceeds the
                        credit limit in respect of the Payment Details provided;
                      </span>
                    </div>
                    <div>
                      <span> (b) your payment card has expired; or </span>
                    </div>
                    <div>
                      <span>
                        (c) circumstances beyond Ninjacart's control (such as,
                        but not limited to, power outages, interruptions of
                        cellular service, or any other interferences from an
                        outside force), acts of God, prevent the execution of
                        the transaction.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tc">
                <div className="title">Delivery Tracking Services</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The Platform allows the User to track the status of their
                      running trade vehicle seamlessly. The User agrees and
                      understands that the delivery time, distance and other
                      details available in the tracking mode is an approximate
                      estimate and may vary based on the information obtained
                      from the User or its delivery partner or depend on various
                      other factors such as real time analysis of traffic and
                      weather conditions, seasonal peaks or such other
                      parameters. Ninjacart shall not be responsible for any
                      delay in the delivery of trade deliverables or the
                      accuracy of the status of the vehicle.
                    </span>
                  </div>
                </div>
              </div>
              <div className="tc">
                <div className="title">Prohibited Activities</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      Except as expressly permitted in these Terms, you confirm
                      and undertake that you will not:
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <div>
                      <span>
                        i. Use the Platform in any illegal manner or any manner
                        which encourages or promotes illegal activities.
                      </span>
                    </div>
                    <div>
                      <span>
                        ii. Remove, alter, cover, or distort any copyright,
                        trademark, or other proprietary rights notice we include
                        in or through our Services or Service Content;
                      </span>
                    </div>
                    <div>
                      <span>
                        iii. Circumvent, disable or otherwise interfere with our
                        security-related features including, without limitation,
                        any features that prevent or restrict the use of or
                        copying of any software or other Service Content;
                      </span>
                    </div>
                    <div>
                      <span>
                        iv. Attempt to crawl, scrap, extract, and harvest or
                        otherwise access any data or content of the website via
                        any automated means or systematic means;
                      </span>
                    </div>
                    <div>
                      <span>
                        v. Collect or harvest any personally identifiable
                        information or non-personally identifiable information
                        from our Platform and/or Services including, without
                        limitation, user names, passwords, email addresses;
                      </span>
                    </div>
                    <div>
                      <span>
                        vi. Attempt to test the vulnerability of the website by
                        using means to disproportionately put load on the
                        Platform's infrastructure.
                      </span>
                    </div>
                    <div>
                      <span>
                        vii. Upload or distribute any virus, bugs, trap doors,
                        trojan horse, worm, keystroke logger, rootkit, harmful
                        codes or other similar software or programs that may
                        damage the functioning of the Platform or another's
                        computer.
                      </span>
                    </div>
                    <div>
                      <span>
                        viii. Decompile, modify, adapt, translate, disassemble
                        or reverse engineer or re-format or frame whole or any
                        portion of our Platform or other Service Content.
                      </span>
                    </div>
                    <div>
                      <span>
                        ix. Use network-monitoring software to determine
                        architecture of or extract usage data from our Platform
                        and/or Services;
                      </span>
                    </div>
                    <div>
                      <span>
                        x. Make efforts to subvert the Platform's navigational
                        structure by hacking into the Platform database to
                        obtain information.
                      </span>
                    </div>
                    <div>
                      <span>
                        xi. Encourage conduct that violates any applicable laws,
                        either civil or criminal, or impersonate another User,
                        person, or entity;
                      </span>
                    </div>
                    <div>
                      <span>
                        xii. Engage in any conduct that restricts or inhibits
                        any other User from using or enjoying our Services.
                      </span>
                    </div>
                    <div>
                      <span>
                        xiii. Make any defamatory, derogatory, abusive,
                        inappropriate, indecent comment or statement about the
                        Platform and/or Ninjacart and its affiliates,
                        associates, partners or any property owned by Ninjacart.
                      </span>
                    </div>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    Ninjacart reserves the right to suspend/cancel/terminate
                    your use of using the Platform, if Ninjacart has a reason to
                    believe that you have indulged in any of the prohibited
                    activities mentioned above, or have breached any of the
                    Terms. You agree to fully cooperate with us to investigate
                    any suspected or actual activity that is in breach of these
                    Terms.
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div className="tc">
                <div className="title">Warranties and Representation</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      No warranty of any kind, implied, express or statutory,
                      including but not limited to the warranties of
                      non-infringement of third party rights, title,
                      merchantability, satisfactory quality, or fitness for a
                      particular purpose, is given with regard to the Services
                      or the Platform.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The User acknowledges that they have not solely relied on
                      any representation/warranty made by Ninjacart or its Third
                      Parties, and have made independent assessments of the
                      Services offered through the Platform.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The User agrees acknowledges that Ninjacart is not a
                      payment aggregator or payment gateway. It uses Third
                      Parties to facilitate enabling the transactions of the
                      Users. The User also agrees that Ninjacart is not a party
                      to any transaction, nor does it partner or endorse any
                      transactions carried by the Users through the Platform.
                      Ninjacart's Platform only mediates a Users interaction
                      with the Third Party (i.e., payment gateway service
                      provider) for seamless transactions. Therefore, Ninjacart
                      is not a party to any transaction done by the Users via
                      this Platform. Notwithstanding anything to the contrary
                      contained herein, neither Ninjacart nor any of its
                      affiliates or related parties shall have any liability to
                      the User or any third party for any indirect, incidental,
                      special or consequential damages or any loss of revenue or
                      profits arising under, directly or indirectly, or
                      relating, in any manner whatsoever, to these Terms or the
                      Services.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The User specifically represents and warrants that:
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <div>
                      <span>
                        ● The User shall be solely responsible for all the goods
                        and services which the User purchases or sells via the
                        Platform, including their description, price, fees, tax,
                        any required legal disclosures, compliance and any
                        offers or promotional content.
                      </span>
                    </div>
                    <div>
                      <span>
                        ● The User shall be solely responsible for setting and
                        displaying the terms and conditions for sales on the
                        Platform, including without limitation policies for
                        sale, refund, return and the Users timelines for
                        delivery etc.
                      </span>
                    </div>
                    <div>
                      <span>
                        ● The User shall clearly inform/communicate to its
                        buyers that the sale of goods and services are done by
                        the User and not by Ninjacart.
                      </span>
                    </div>
                    <div>
                      <span>
                        ● In the event, there is any defect, loss or discrepancy
                        in the quality or quantity of the goods and services
                        sold or purchased by the User, the User agrees that it
                        shall resolve the matter with the relevant buyer/seller
                        on its own and Ninjacart shall not be made liable or
                        responsible for any issue arising out of said goods and
                        services.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div className="tc">
                <div className="title">Disclaimers</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The Platform and Services are provided to you on “as is”
                      and “as available” basis without warranty of any kind
                      either express or implied. We do not warrant that the
                      Services provided by the Platform will be uninterrupted or
                      error free or that the Platform or its hosting server are
                      free from viruses or other harmful components. Further,
                      the User acknowledges that on occasion the Platform may be
                      temporarily down due to periodic maintenance, technical
                      issues, or for any security reasons beyond Ninjacart's
                      control. In such instances of downtime, Ninjacart shall
                      not be held liable for any losses which Users may incur.
                      However, Ninjacart shall make best efforts to rectify the
                      issue causing the downtime, and make the Platform
                      available at the earliest.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      Furthermore, the User understands that Ninjacart is merely
                      a facilitator that provides software infrastructure to
                      Users (i.e., buyer and sellers) to record trade and ease
                      the transaction process. The User agrees and acknowledges
                      that Ninjacart is not responsible for any information made
                      available on Platform, and that Ninjacart makes no
                      warranties with regard to the accuracy, completeness, or
                      correctness of such information. The material on the
                      Platform is provided for general information purposes only
                      and should not be relied upon or used as the sole basis
                      for making decisions, i.e., without consulting primary,
                      more accurate, more complete, or updated sources of
                      information. Any reliance on the material on Platform is
                      at the User's own risk.. We reserve the right to modify
                      the contents of Platform at any time, but we are not
                      obligated to do so. The User agrees and acknowledges that
                      it is the User's responsibility to monitor changes to the
                      Terms.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The Website may contain links to Third Party services and
                      resources. The services and resources provided by Third
                      Parties are not controlled by Ninjacart, and when using
                      them Users are bound by the terms of said Third Party. We
                      do not ensure the availability and content of such Third
                      Party resources. Any concerns regarding any such Third
                      Party service or resource, or any link thereto, should be
                      directed to the relevant Third Party. These resources or
                      links provided by Ninjacart are provided to the User only
                      as a convenience and the inclusion of any Third Party
                      resources, services or link does not imply any endorsement
                      by Ninjacart.
                    </span>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div className="tc">
                <div className="title">User Content</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      (a) You may be permitted to post, upload, transmit
                      through, or otherwise make available through our Platform
                      and/or Services, messages, text, illustrations, data,
                      files, images, graphics, photos, comments, feedbacks,
                      suggestions, sounds, music, videos, information, content,
                      and/or other materials (hereinafter referred to as “User
                      Content”). Subject to the rights and license you grant
                      Ninjacart herein, you retain all right, title and interest
                      in your User Content. We do not guarantee any
                      confidentiality with respect to User Content even if it is
                      not published through our Services. It is the Users sole
                      responsibility to monitor and protect any intellectual
                      property rights that they may have in their User Content,
                      and we do not accept any responsibility for the same.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      (b) You hereby represent and warrant that you shall not
                      submit or upload any User Content to the Platform that
                      violates or infringes any third parties intellectual
                      property rights (which includes patent, trademark,
                      copyright or any other proprietary right). You are solely
                      liable for any damage resulting from such
                      violation/infringement of third party rights or from any
                      other harm resulting from User Content that you submit or
                      upload on the Platform.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      (c) You confirm and undertake that you will not host,
                      display, upload, modify, publish, transmit, update or
                      share any User Content that:
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <div>
                      <span>
                        {' '}
                        i. belongs to any other person over which you don't have
                        any right;{' '}
                      </span>
                    </div>
                    <div>
                      <span>
                        ii. is defamatory, obscene, pornographic, paedophilic,
                        invasive of another's privacy, including bodily privacy,
                        insulting or harassing on the basis of gender,
                        libellous, racially or ethnically objectionable,
                        relating or encouraging money laundering or gambling, or
                        otherwise inconsistent with or contrary to the laws in
                        force;
                      </span>
                    </div>
                    <div>
                      <span>
                        iii. encourages conduct that would constitute a criminal
                        offense, gives rise to civil liability or otherwise
                        violates any law;
                      </span>
                    </div>
                    <div>
                      <span>
                        {' '}
                        iv. is harmful or inappropriate for minors in any manner
                        whatsoever;{' '}
                      </span>
                    </div>
                    <div>
                      <span>
                        v. deceives or misleads the addressee about the origin
                        of the message or knowingly and intentionally
                        communicates any information which is patently false or
                        misleading in nature but may reasonably be perceived as
                        a fact;
                      </span>
                    </div>
                    <div>
                      <span> vi. impersonates another person; </span>
                    </div>
                    <div>
                      <span>
                        {' '}
                        vii. violates any state, or central, or international
                        laws;{' '}
                      </span>
                    </div>
                    <div>
                      <span>
                        {' '}
                        viii. infringes any patent, trademark, copyright or
                        other proprietary rights;{' '}
                      </span>
                    </div>
                    <div>
                      <span>
                        ix. threatens the unity, integrity, defence, security or
                        sovereignty of India, friendly relations with foreign
                        States, or public order, or causes incitement to the
                        commission of any cognisable offence or prevents
                        investigation of any offence or is insulting other
                        nation;
                      </span>
                    </div>
                    <div>
                      <span>
                        x. contains software virus or any other computer code,
                        file or program designed to interrupt, destroy or limit
                        the functionality of any computer resource;
                      </span>
                    </div>
                    <div>
                      <span>
                        xi. is patently false and untrue, and is written or
                        published in any form, with the intent to mislead or
                        harass a person, entity or agency for financial gain or
                        to cause any injury to any person
                      </span>
                    </div>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      (d) You further represent and warrant that the User
                      Content submitted to us is not subject to any
                      confidentiality obligations. By submitting and/or
                      uploading the User Content on the Platform, you expressly
                      grant Ninjacart a worldwide, royalty-free, perpetual,
                      irrevocable and freely transferable license to use, copy,
                      distribute, display, make derivative copies, and modify
                      the User Content without any restrictions. You also agree
                      that such license will not revert to you due to any
                      non-utilization of the User Content by Ninjacart. You also
                      agree to grant Ninjacart the right to use the name that
                      has been submitted with the User Content, in connection
                      with such User Content. However, that all such uses will
                      be consistent with the terms of our Privacy Policy.(e)
                      Notwithstanding the generality of the foregoing, we
                      reserve the right to display advertisements in connection
                      with your User Content and to use your User Content for
                      advertising, marketing, promotional, and other commercial
                      purposes. You acknowledge and agree that your User Content
                      may be included on the websites and advertising networks
                      of our Third Party partners such as distribution partners,
                      marketing partners, accounts.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      (f) We have the right, but not the obligation, to monitor
                      User Content. We have the right, in our sole discretion
                      and for any reason whatsoever to edit, refuse to post,
                      remove, or disable access to any User Content.
                    </span>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div className="tc">
                <div className="title">Indemnity</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      You shall indemnify and hold harmless Ninjacart, its
                      officers, directors, employees, partners, successors,
                      agents, distribution partners, affiliates, subsidiaries,
                      and their related companies (hereinafter collectively
                      referred to as the “Indemnified Parties”) from any claim
                      or demand, or actions including reasonable attorneys fees,
                      made by any third party or penalty imposed due to or
                      arising out of your breach of this Terms, and related
                      policies, or your violation of any law, rule, regulation,
                      or the rights including the infringement of intellectual
                      property rights of any third party.
                    </span>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div className="tc">
                <div className="title">Limitation of Liability</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      Our liability to you is limited to the minimum extent
                      permitted by law. In no event shall Ninjacart, its
                      affiliates or any of their respective officers, directors,
                      employees, agents or service providers be liable for
                      indirect, incidental, special, consequential or exemplary
                      damages (even if we have been advised of the possibility
                      of such damage) arising from or directly or indirectly
                      related to
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <div>
                      <span>
                        (i) the use of or inability to use the Platform or any
                        of the Services or materials provided by us.
                      </span>
                    </div>
                    <div>
                      <span>
                        (ii) any downtime costs, loss of revenue or business
                        opportunities, loss of profit, loss of anticipated
                        savings or business, loss of data, loss of goodwill or
                        loss of value of any equipment including software;
                      </span>
                    </div>
                    <div>
                      <span>
                        (iii) any loss or damage arising as a result of a
                        disclosure/sharing or hacking of the User's Account
                        details (such as password details), and any improper
                        usage, failure or malfunction of any computer or mobile
                        phone, unavailability of an electricity connection,
                        other telecommunications equipment, any other services
                        or equipment necessary to access Ninjacart's products
                        and services;
                      </span>
                    </div>
                    <div>
                      <span>
                        (iv) act or omission of any third party including but
                        not limited to any equipment or software providers, any
                        service providers, any network providers (including but
                        not limited to telecommunications providers, internet
                        browser providers and internet access providers), or any
                        agent or subcontractor of any of the foregoing;
                      </span>
                    </div>
                    <div>
                      <span>
                        (v) theft or loss of the User's computer, mobile phone,
                        the User's data, the User's login details and password,
                        hardware and/or equipment on which the Platforms are
                        accessed or operated.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div className="tc">
                <div className="title">Intellectual Property Rights</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      All the contents including without limitation to
                      information, graphics, data, text, layout, music, sound,
                      photograph, arrangements, source code, software
                      compilations or any other materials, contained or
                      available in the Platform (excluding User Content) vest
                      solely with Ninjacart. The User agrees not to do any of
                      the following without the prior written consent of
                      Ninjacart:
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <div>
                      <span>
                        (a) make copies of the Platform for purpose of
                        distribution to others or distribute the Platform to
                        others, whether directly or indirectly;
                      </span>
                    </div>
                    <div>
                      <span>
                        (b) decompile, reverse engineer, disassemble or
                        otherwise reduce the software to human-perceivable form;
                      </span>
                    </div>
                    <div>
                      <span>
                        (c) modify, adapt, translate, rent or sublicense,
                        assign, loan, resell for profit or distribute the
                        Platform or create derivative works based thereon.
                      </span>
                    </div>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      The trademark, logo and service mark displayed on or in
                      the Platform is the exclusive property of Ninjacart as it
                      reserves all the intellectual property right in these
                      contents. The User agree not to use, reproduce, sell,
                      transmit, create derivate work or distribute any content
                      from the Platform (excluding User Content). Additionally,
                      you agree not to use our trade dress, or copy the look and
                      feel of our Platform or its design, without our prior
                      written consent. Use of the Platform does not entitle the
                      User to make any unauthorized use of any protected content
                      (which includes Ninjacart's intellectual property and
                      third-party intellectual property). User may use the
                      protected content solely for personal use and will make no
                      other use of the content without express written
                      permission of Ninja App.
                    </span>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div className="tc">
                <div className="title">Infringement Policy</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      We take matters related to intellectual property rights,
                      privacy and confidentiality very seriously. We do not
                      encourage the posting of any copyrighted or infringing
                      materials on our Platform. Further, while we prohibit
                      Users from posting any defamatory or derogatory contents
                      on the Platform, we cannot ensure that no such content has
                      been submitted or uploaded on the Platform. The User
                      Content posted is not reviewed prior to the submission.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      Should you have any complaints regarding the Platform,
                      including but not limited to abuse and misuse of the
                      Platform, copyright infringement and the like, or any
                      issues related to data privacy or defamatory content,
                      please report the same at ninja-app@ninja.in.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      All the notices of legal claim can be submitted at email:
                      <span className="link">
                        <a href="#">legal@ninjacart.com</a>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div className="tc">
                <div className="title">Account Termination</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      We reserve the right to suspend or terminate your Account
                      or refuse any or all current or future use of the Platform
                      without giving prior notice, if we find that you have
                      violated any of the Terms, and related policies or
                      guidelines. Such termination will result in the
                      deactivation or deletion of your Account or your access to
                      the Platform.
                    </span>
                  </div>
                  <div className="line-break"></div>
                  <div>
                    <span>
                      You also reserve the right to terminate your account or
                      stop taking our services, in the event you are
                      dissatisfied with our Services
                    </span>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div className="tc">
                <div className="title">Governing Law and Jurisdiction</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      These terms and conditions will be governed by and
                      construed in accordance with the laws applicable in India
                      and any dispute arising out of or in connection to these
                      terms of use shall be subject to the exclusive
                      jurisdiction of the applicable court under the
                      jurisdiction of Bengaluru, Karnataka.
                    </span>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div className="tc">
                <div className="title">General Terms</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <div>
                      <span>
                        (a) The section headings used herein are for convenience
                        only and shall not be given any legal importance.
                      </span>
                    </div>
                    <div>
                      <span>
                        (b) If a provision of these Terms is determined by any
                        court or other competent authority to be unlawful and/or
                        unenforceable, the other provisions will continue in
                        effect. If any unlawful and/or unenforceable provision
                        would be lawful or enforceable if part of it were
                        deleted, that part will be deemed to be deleted, and the
                        rest of the Terms will continue in effect.
                      </span>
                    </div>
                    <div>
                      <span>
                        (c) Where we have provided you with a translation of the
                        English language version of these Terms, our Privacy
                        Policy or other relevant terms, you agree that the
                        translation is provided for your convenience only and
                        that the English version governs your relationship with
                        us. The English version takes precedence if there is any
                        contradiction between the English and translated
                        versions.
                      </span>
                    </div>
                    <div>
                      <span>
                        (d) No waiver of any provision of these Terms shall be
                        binding unless executed and notified by Ninjacart in
                        writing to you. No waiver of any of the provisions of
                        these Terms shall be deemed or shall constitute a waiver
                        of any other provision and no waiver shall constitute a
                        continuing waiver. You hereby waive any present or
                        future claims you have against Ninjacart arising from
                        your use of the Platform.
                      </span>
                    </div>
                    <div>
                      <span>
                        (e) These Terms including the Privacy Policy and any
                        additional terms available in the Website, constitutes
                        the entire agreement between Ninja App and the User with
                        regard to the subject matter of these Terms and shall
                        supersede any and all prior agreements, negotiations,
                        correspondence, undertakings, promises, covenants,
                        arrangements, communications, representations, and
                        warranties (if any) between the Ninjacart and the User,
                        whether oral or written.
                      </span>
                    </div>
                    <div>
                      <span>
                        (f) Ninjacart shall not be made liable for any breach of
                        these Terms due to any force-majeure event that prevents
                        or delays performance of its obligations under these
                        Terms, such as an act of God, fire, lightning, acts of
                        terrorism or war, epidemics, pandemics, explosion,
                        flood, adverse weather conditions, power failures,
                        failure in any communication systems, equipment
                        breakdown, strikes, lock-out or any other cause beyond
                        our Control.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div className="tc">
                <div className="title">Notices</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      All notices to the Users will be sent to their mails or
                      will be posted on the Platform. The Users, who have
                      maintained their e-mail address with us, will be receiving
                      notice in such e-mail address only. Email notices are
                      deemed received the day after transmission if properly
                      addressed to the intended recipient.
                    </span>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div className="tc">
                <div className="title">Contact Us</div>
                <div className="description">
                  <div className="line-break"></div>
                  <div>
                    <span>
                      In case of any queries, the user can contact us at
                      <span
                        onClick={(_) =>
                          shareViaEmailSupport('support@ninja.in')
                        }
                      >
                        <a style={{ color: '#00008b' }}>support@ninja.in</a>
                      </span>
                      or call us at <strong>080-35018270</strong>. Thank you for
                      using our Services!
                    </span>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <div id="credit-facility-container">
                <div className="tc">
                  <div className="title content-center">
                    <strong>Credit Facility</strong>
                  </div>
                  <div className="line-break"></div>
                  <div className="description">
                    These Credit Facility Terms are to be read with, and are
                    subject to the Ninja App Terms (accessible here). All
                    capitalized terms used herein shall have the meaning
                    ascribed to them under the Terms, unless otherwise expressly
                    defined herein. If you choose to avail Credit Facilities
                    from our partner Lenders, these Credit Facility Terms will
                    apply to you.
                  </div>
                </div>
                <div className="tc">
                  <div className="title">Introduction</div>
                  <div className="line-break"></div>
                  <div className="description">
                    <div>
                      <span>The Ninja App</span>
                    </div>
                    <div className="line-break"></div>
                    <div>
                      <span>
                        (i) allows Users who meet certain eligibility criteria
                        to apply for and avail Credit Facilities from our
                        partner Lenders,
                      </span>
                    </div>
                    <div>
                      <span>
                        (ii) facilitates User repayment of the Credit
                        Facilities, and
                      </span>
                    </div>
                    <div>
                      <span>
                        (iii)allows Users to monitor their loan accounts for the
                        Credit Facilities availed through the Platform from
                        partner Lenders.
                      </span>
                    </div>
                    <div className="line-break"></div>
                    <div>
                      <span>
                        Ninjacart is not a Lender, and not does not lend or
                        offer Credit Facilities. Ninjacart partners with Lenders
                        in order to facilitate eligible User access to Credit
                        Facilities. Ninjacart is not a party to any Credit
                        Facility arrangement and all contractual arrangement for
                        Credit Facilities are solely between the eligible User
                        and the partner Lender.
                      </span>
                    </div>
                  </div>
                </div>
                <div className="tc">
                  <div className="title">Definitions</div>
                  <div className="line-break"></div>
                  <div className="description">
                    <div>
                      <span>
                        (a) the term “Credit Facility” or “Credit Facilities” as
                        the context may require, refers to the line of credit
                        facilities granted by partner Lenders to Users of the
                        Platform who meet the eligibility criteria prescribed by
                        the relevant partner Lender.
                      </span>
                    </div>
                    <div>
                      <span>
                        (b) the term “Lender” or “Lenders” as the context may
                        require, refers to banks, non-banking finance companies
                        and other Reserve Bank of India authorized lending
                        institutions that offer credit facilities to eligible
                        Users via the Platform.
                      </span>
                    </div>
                    <div>
                      <span>
                        (c) the term “Loan Agreement” refers to all
                        documentation and agreements, such as the sanction
                        letter, the ‘Most Important Loan Terms’ etc. which
                        eligible Users must execute in order to avail Credit
                        Facilities from partner Lenders.
                      </span>
                    </div>
                  </div>
                </div>
                <div className="line-break"></div>
                <div className="tc">
                  <div className="title">Representations and Warranties</div>
                  <div className="line-break"></div>
                  <div className="description">
                    <div>
                      <span>
                        For the purposes of availing Credit Facilities from
                        Ninjacart’s partner Lenders, you hereby represent and
                        warrant that:
                      </span>
                    </div>
                    <div>
                      <span>
                        1. you understand and recognise Ninjacart as merely a
                        technology service provider facilitating the interaction
                        between eligible Users and partner Lenders.
                      </span>
                    </div>
                    <div>
                      <span>
                        2. you are (a) an Indian citizen, and (b) 18 years or
                        above and are otherwise legally competent to enter into
                        a binding agreement.
                      </span>
                    </div>
                    <div>
                      <span>
                        3. you will inform Ninjacart and/or partner Lenders of
                        any change in your residential status.
                      </span>
                    </div>
                    <div>
                      <span>
                        4. all User Information provided by, and filled in by
                        you are true, correct, and accurate, and that you have
                        not withheld or suppressed any material User
                        Information.
                      </span>
                    </div>
                    <div>
                      <span>
                        5. you will share any additional User Information
                        required for the processing of Credit Facility
                        applications.
                      </span>
                    </div>
                  </div>
                </div>
                <div className="line-break"></div>
                <div className="tc">
                  <div className="title">User Application</div>
                  <div className="line-break"></div>
                  <div className="description">
                    <div>
                      <span>
                        In order for the User to be able to avail Credit
                        Facilities, the User will need to meet certain
                        eligibility criteria specified by the relevant partner
                        Lender. The User must answer all questions raised on the
                        Platform or otherwise by Ninjacart in relation to the
                        Credit Facility in an honest manner.
                      </span>
                    </div>
                    <div className="line-break"></div>
                    <div className="line-break"></div>
                    <div>
                      <span>
                        Ninjacart may assist its partner Lenders in processing
                        Credit Facility applications made through the Platform
                        by collecting User Information (on behalf of partner
                        Lenders) as required by the partner Lenders, which may
                        include ‘Know Your Customer’ (KYC) data, income, User
                        photographs, purpose of the Credit Facility, bank
                        statements etc. Ninjacart does not engage in the
                        verification of User Information, and such verification
                        is undertaken by partner Lenders. More details regarding
                        the collection and processing of this information are
                        provided in the Privacy Policy. Ninjcart may also
                        monitor User actions associated with the Credit
                        Facility, through the information collected from User’s
                        loan account (i.e., account in which loan amount is
                        transferred by partner Lenders), sales or purchases made
                        via the Platform, successful delivery of User goods
                        etc., by relying on the services of Third Parties.
                      </span>
                    </div>
                    <div className="line-break"></div>
                    <div>
                      <span>
                        Ninjacart may forward Credit Facility applications to
                        partner Lenders based on the metrics shared by said
                        partner Lenders. Ninjacart does not decide on the
                        creditworthiness of any Credit Facility application made
                        by a User. Our partner Lenders may assess the Credit
                        Facility application and upon their sole discretion
                        choose to not grant a Credit Facility to the User. The
                        partner Lender shall have the right but not the
                        obligation to provide the reason for its decision to the
                        User. If the partner Lenders choose to grant eligible
                        Users a Credit Facility, the User will be required to
                      </span>
                    </div>
                    <div className="line-break"></div>
                    <div>
                      <span>
                        (i) execute the Loan Agreements to the partner Lenders
                        satisfaction, and{' '}
                      </span>
                    </div>
                    <div>
                      <span>
                        (ii) to fulfil any other condition prescribed by the
                        partner Lender such as granting the partner Lender a
                        NACH mandate or the Users providing guarantees to
                        partner Lenders for the Credit Facility, as required.
                      </span>
                    </div>
                  </div>
                </div>
                <div className="line-break"></div>
                <div className="tc">
                  <div className="title">Repayment and Collection</div>
                  <div className="line-break"></div>
                  <div className="description">
                    <div>
                      <span>
                        Ninjacart may assist partner Lenders in the collection
                        of the amounts owed to them by eligible Users. Ninjacart
                        may collect these sums owed in the manner prescribed in
                        the Loan Agreement. The terms of the Loan Agreement
                        executed by eligible Users with partner Lenders shall
                        govern any and all consequences associated with the
                        eligible Users inability to repay the borrowed amounts.
                      </span>
                    </div>
                  </div>
                </div>

                <div className="line-break"></div>
                <div className="tc">
                  <div className="title">PRICING POLICY</div>
                  <div className="line-break"></div>
                  <div className="description">
                    <div>
                      <span>
                      All prices for products and services offered through 
                      the Ninja App are listed on the Ninja App or are available upon request. 
                      The Company reserves the right to modify pricing at any time, 
                      at its sole discretion, 
                      with any such modifications effective immediately upon posting on the Ninja App. 
                      The User shall be responsible for any and all applicable taxes, levies, 
                      or other charges imposed by any governmental authority, 
                      and such charges shall be in addition to the listed price. 
                      The Company shall not be liable for any price fluctuations 
                      resulting from changes in taxation or other levies.
                      </span>
                    </div>
                  </div>
                </div>

                <div className="line-break"></div>
                <div className="tc">
                  <div className="title">CANCELLATION POLICY</div>
                  <div className="line-break"></div>
                  <div className="description">
                    <div>
                      <span>
                      Any cancellation of products or services procured through 
                      the Ninja App shall be governed by the cancellation terms and conditions communicated 
                      to the User at the time of purchase or as otherwise made available on the Ninja App. 
                      The Company reserves the right to amend these terms at its sole discretion, 
                      with any such amendments effective upon posting on the Ninja App.
                      </span>
                    </div>
                  </div>
                </div>

                <div className="line-break"></div>
                <div className="tc">
                  <div className="title">REFUND POLICY</div>
                  <div className="line-break"></div>
                  <div className="description">
                    <div>
                      <span>
                      Ninjacart is a B2B company and hence does not support refunds. 
                      Ninjacart operates with perishables and accepts payment only after delivery and acceptance by the customer, 
                      hence the scenario for a refund does not arise. In case you have any chargeback related queries, please write to{' '}
                        <span
                          onClick={(_) =>
                            shareViaEmailSupport('chargeback@ninjacart.com')
                          }
                        >
                          <a style={{ color: '#00008b' }}>chargeback@ninjacart.com</a>
                        </span>. 
                      </span>
                    </div>
                  </div>
                </div>

                <div className="line-break"></div>
                <div className="tc">
                  <div className="title">
                    Eligible User Consents and Authorisations
                  </div>
                  <div className="line-break"></div>
                  <div className="description">
                    <div>
                      <span>
                        By clicking ‘I Accept’, you consent to, and authorize
                        Ninjacart to process or share User Information collected
                        from you with partner Lenders and relevant Third Parties
                        for
                      </span>
                    </div>
                    <div className="line-break"></div>
                    <div>
                      <span>(i) availing the Credit Facility,and </span>
                    </div>
                    <div>
                      <span>
                        (ii) for purposes outlined under these Credit Facility
                        Terms. You acknowledge that your provision of Aadhaar
                        details is purely voluntary, and you may provide other
                        identification documents such as any other two ID &
                        address proof. You will not be denied any service by
                        Ninjacart merely for the reason of not submitting
                        Aadhaar details. You consent to, and authorise Ninjacart
                        to act as your authorised representative in order to
                        receive your credit information from authorised credit
                        bureaus to provide services to you, including but not
                        limited to the provision of support services associated
                        with the Credit Facility. Ninjacart will not share your
                        credit information with any Third Party. The User will
                        also be required to provide additional consents and
                        authorisations to partner Lenders under the Loan
                        Agreement and agrees that any processing of User
                        Information by partner Lenders will be pursuant to said
                        consent.
                      </span>
                    </div>
                  </div>
                </div>
                <div className="tc">
                  <div className="title">Grievance Redressal</div>
                  <div className="line-break"></div>
                  <div className="description">
                    <div>
                      <span>
                        In case of any complaints or grievances with regard to
                        the Credit Facility availed from partner Lenders, you
                        may contact us at
                        <span
                          onClick={(_) =>
                            shareViaEmailSupport('support@ninja.in')
                          }
                        >
                          <a style={{ color: '#00008b' }}>support@ninja.in</a>
                        </span>
                        or call us at <strong>080-35018270</strong>. Thank you
                        for using our Services!
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ backgroundColor: 'white !important' }}>
          <div className="ninja-bg">
            <div className="left">
              <div onClick={(_) => back()}></div>
            </div>
            <div className="center text-white">
              {'resource.termsAndConditions'}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default TermsCondition;
